import { RouteConfig } from 'vue-router'

const publicRoutes: Array<RouteConfig> = [

]

export default publicRoutes
